"use strict";
'use es6';
/** @module debounce */

/** Ensures a given task doesn't fire so often as to brick browser
 * performance. Returns a function, that, as long as it continues
 * to be invoked, will not be triggered.
 *
 * Usage:
 *   // Place your code within {}
 *   const myEfficientFn = debounce(() => {}, 250);
 *   window.addEventListener('resize', myEfficientFn);
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _this = void 0;

var _default = function _default(func, wait, immediate) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(_this, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(_this, args);
    }
  };
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/wtDebounce.js
// module id = 842
// module chunks = 5 6